import { ISODuration } from "../chart";

export const DefaultDataInterval: ISODuration = "P1D";
export const DefaultTimePeriod: ISODuration = "P3M";
